import { ICardDriverRanking, CardDriverRanking } from "@sky-it-livedata/livedata-sports-design-system";

import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { DataCardDriverRanking } from "./types";

import transformQuery from "./transformers/query-transformer";
import { useIntcmp } from "../../hooks/useIntcmp";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<DataCardDriverRanking>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

export const getServerProps = ({
  props,
}: WidgetContext<DataCardDriverRanking>): ICardDriverRanking => {
  return transformQuery(props);
}

const ResultsContainer = ({
  props,
  ...rest
}: WidgetContext<ICardDriverRanking>) => {
  log({ props, ...rest });
  const intCmpEventHandler = useIntcmp();

  return (
    <div onClick={intCmpEventHandler}>
        <CardDriverRanking {...props} />
    </div>
  );
}

export default ResultsContainer;